import AgGridTextLink from '@/components/ag-grid-helpers/AgGridTextLink'
import { searchResultsRouteMap } from '@/utils/search-results-route-map'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        getRowNodeId: data => {
          return data.uuid || data.id
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            cellRendererFramework: AgGridTextLink,
            cellRendererParams: params => {
              if (!params?.data || !params?.value) return

              let routeId

              if (params.tag === 'subscription_period') routeId = params.data.subscription_id
              else if (['invoice_vendor', 'invoice_publisher', 'note'].includes(params.data.tag))
                routeId = params.data.provider_id
              else routeId = params.data.id

              return {
                text: params.value,
                route: searchResultsRouteMap[params.data.tag](routeId, params.data.provider_type)
              }
            }
          },
          {
            headerName: 'Tag',
            field: 'tag',
            cellRenderer: params => params.value,
            cellClassRules: {
              vendor: params => params.data?.tag === 'vendor',
              publisher: params => params.data?.tag === 'publisher',
              product: params => params.data?.tag === 'product',
              subscription: params => params.data?.tag === 'subscription',
              license: params => params.data?.tag === 'license',
              'subscription-period': params => params.data?.tag === 'subscription_period',
              invoice: params => ['invoice_vendor', 'invoice_publisher'].includes(params.data?.tag),
              note: params => params.data?.tag === 'note',
              publication: params => params.data?.tag === 'publication'
            }
          }
        ],
        defaultColDef: {
          suppressMenu: true,
          sortable: false
        },
        cacheBlockSize: 40,
        pagination: false,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        domLayout: 'normal'
      }
    }
  }
}
